import React from 'react';
import {connect} from 'react-redux';
import {Button, Grid, Header, Segment, Image} from 'semantic-ui-react';
import {ENDPOINT_LOGIN_GOV} from 'common/endpoints';
import LoginGovLogo from 'go/images/logingov_logo_white.svg';

export class LoginGov extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    window.location.href = `${ENDPOINT_LOGIN_GOV}authenticate`;
  };

  render() {
    return (
      <Segment>
        <Header as="h3" dividing color="blue">
          FEMA customers
        </Header>
        <Grid className="loginGov">
          <Grid.Row>
            <Grid.Column>
              <p>
                FEMA Grants Outcomes is now using Login.gov to manage your login and
                authentication experience. To view or manage your account, sign in to or
                create an account with Login.gov.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Button primary compact onClick={this.handleClick}>
                <span>Sign in with</span>{' '}
                <Image src={LoginGovLogo} size="tiny" spaced className="loginGov__icon" />
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {};
};

export const mapStateToProps = (state) => {
  return {
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginGov);
